
import { TranslationSet } from '../../types';

export const galleryPhotoManagement: TranslationSet = {
  'gallery.deletePhoto': {
    en: 'Delete Photo',
    ja: '写真を削除',
    es: 'Eliminar foto',
    zh: '删除照片',
    fa: 'حذف عکس'
  },
  'gallery.deletePhotoConfirm': {
    en: 'Are you sure you want to delete this photo?',
    ja: 'この写真を削除してもよろしいですか？',
    es: '¿Estás seguro de que quieres eliminar esta foto?',
    zh: '您确定要删除此照片吗？',
    fa: 'آیا مطمئن هستید که می‌خواهید این عکس را حذف کنید؟'
  },
  'gallery.photoDeletedSuccess': {
    en: 'Photo deleted successfully!',
    ja: '写真が正常に削除されました！',
    es: '¡Foto eliminada con éxito!',
    zh: '照片删除成功！',
    fa: 'عکس با موفقیت حذف شد!'
  },
  'gallery.photoDeleteFailed': {
    en: 'Failed to delete photo',
    ja: '写真の削除に失敗しました',
    es: 'Error al eliminar la foto',
    zh: '照片删除失败',
    fa: 'حذف عکس با خطا مواجه شد'
  },
  'gallery.deleting': {
    en: 'Deleting...',
    ja: '削除中...',
    es: 'Eliminando...',
    zh: '删除中...',
    fa: 'در حال حذف...'
  },
  'gallery.editPhotoTitle': {
    en: 'Edit Photo Title',
    ja: '写真タイトルを編集',
    es: 'Editar título de la foto',
    zh: '编辑照片标题',
    fa: 'ویرایش عنوان عکس'
  },
  'gallery.editPhotoDetails': {
    en: 'Edit Photo Details',
    ja: '写真の詳細を編集',
    es: 'Editar detalles de la foto',
    zh: '编辑照片详情',
    fa: 'ویرایش جزئیات عکس'
  },
  'gallery.photoUpdateSuccess': {
    en: 'Photo details updated successfully!',
    ja: '写真の詳細が正常に更新されました！',
    es: '¡Detalles de la foto actualizados con éxito!',
    zh: '照片详情更新成功！',
    fa: 'جزئیات عکس با موفقیت به‌روزرسانی شد!'
  },
  'gallery.photoUpdateFailed': {
    en: 'Failed to update photo details',
    ja: '写真の詳細の更新に失敗しました',
    es: 'Error al actualizar los detalles de la foto',
    zh: '照片详情更新失败',
    fa: 'به‌روزرسانی جزئیات عکس با خطا مواجه شد'
  },
  'gallery.viewFullSize': {
    en: 'View Full Size',
    ja: 'フルサイズで表示',
    es: 'Ver tamaño completo',
    zh: '查看原尺寸',
    fa: 'نمایش اندازه کامل'
  },
  'gallery.uploadDate': {
    en: 'Upload Date',
    ja: 'アップロード日',
    es: 'Fecha de subida',
    zh: '上传日期',
    fa: 'تاریخ بارگذاری'
  },
  'gallery.noDateSet': {
    en: 'No date set',
    ja: '日付が設定されていません',
    es: 'Sin fecha establecida',
    zh: '未设置日期',
    fa: 'تاریخ تنظیم نشده است'
  },
  'gallery.sortBy': {
    en: 'Sort by',
    ja: '並び替え',
    es: 'Ordenar por',
    zh: '排序方式',
    fa: 'مرتب‌سازی بر اساس'
  },
  'gallery.newest': {
    en: 'Newest',
    ja: '最新',
    es: 'Más reciente',
    zh: '最新',
    fa: 'جدیدترین'
  },
  'gallery.oldest': {
    en: 'Oldest',
    ja: '最古',
    es: 'Más antiguo',
    zh: '最早',
    fa: 'قدیمی‌ترین'
  },
  'gallery.guestDemo': {
    en: 'Gallery Preview',
    ja: 'ギャラリープレビュー',
    es: 'Vista previa de la galería',
    zh: '相册预览',
    fa: 'پیش‌نمایش گالری'
  },
  'gallery.sampleDescription': {
    en: 'Browse our sample gallery to see what you can create with a premium account. Upload and organize your own photos when you sign up!',
    ja: 'サンプルギャラリーを閲覧して、プレミアムアカウントで作成できるものを確認してください。サインアップすると、自分の写真をアップロードして整理できます！',
    es: 'Navega por nuestra galería de muestras para ver lo que puedes crear con una cuenta premium. ¡Sube y organiza tus propias fotos cuando te registres!',
    zh: '浏览我们的示例相册，了解您可以使用高级账户创建的内容。注册后上传和整理您自己的照片！',
    fa: 'گالری نمونه ما را مرور کنید تا ببینید با حساب ویژه چه چیزی می‌توانید ایجاد کنید. هنگام ثبت نام، عکس‌های خود را آپلود و سازماندهی کنید!'
  },
  'gallery.signInToViewPhotos': {
    en: 'Sign in to upload and manage your own photos',
    ja: 'サインインして自分の写真をアップロードして管理する',
    es: 'Inicia sesión para subir y administrar tus propias fotos',
    zh: '登录以上传和管理您自己的照片',
    fa: 'برای آپلود و مدیریت عکس‌های خود وارد شوید'
  },
  'gallery.premiumFeature': {
    en: 'Premium Feature',
    ja: 'プレミアム機能',
    es: 'Función premium',
    zh: '高级功能',
    fa: 'ویژگی حساب ویژه'
  },
  'gallery.selectWeekToPreview': {
    en: 'Select a week to see a preview',
    ja: 'プレビューを表示する週を選択してください',
    es: 'Selecciona una semana para ver una vista previa',
    zh: '选择一周以查看预览',
    fa: 'یک هفته را برای مشاهده پیش‌نمایش انتخاب کنید'
  },
  'gallery.untitledPhoto': {
    en: 'Untitled Photo',
    ja: '無題の写真',
    es: 'Foto sin título',
    zh: '无标题照片',
    fa: 'عکس بدون عنوان'
  },
  'gallery.editPhoto': {
    en: 'Edit Photo',
    ja: '写真を編集',
    es: 'Editar foto',
    zh: '编辑照片',
    fa: 'ویرایش عکس'
  },
  'gallery.photoFromDiary': {
    en: 'Photo from diary entry',
    ja: '日記からの写真',
    es: 'Foto de entrada de diario',
    zh: '来自日记的照片',
    fa: 'عکس از یادداشت روزانه'
  }
};
